import { render } from "./DropDown.vue?vue&type=template&id=ff70bd6e&scoped=true&ts=true"
import script from "./DropDown.vue?vue&type=script&lang=ts"
export * from "./DropDown.vue?vue&type=script&lang=ts"

import "./DropDown.vue?vue&type=style&index=0&id=ff70bd6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff70bd6e"]])

export default __exports__